/* CombatCorner : chargement differe du contenu du mega-menu.
   La page recoit un menu leger (liens seuls). Le menu complet (vignettes, cartes, promos)
   est precharge apres l'affichage, puis insere au premier toucher / survol / focus du menu. */
(function () {
  var menu = document.querySelector('main-menu');
  if (!menu || !menu.querySelector('[data-cc-nav-lite]')) return;

  var section = menu.closest('.shopify-section');
  if (!section) return;
  var sectionId = section.id.replace('shopify-section-', '');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var url = root + 'search?q=cc-menu-complet&section_id=' + encodeURIComponent(sectionId);
  var themeId = (window.Shopify && Shopify.theme && Shopify.theme.id) || '';
  var storageKey = 'ccMenu:' + themeId + ':' + root;
  var TTL = 10 * 60 * 1000;
  var loading = null;
  var injected = false;

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (c && Date.now() - c.t < TTL && c.m) return c.m;
    } catch (e) { /* ignore */ }
    return null;
  }

  function load() {
    if (loading) return loading;
    var cached = readCache();
    if (cached) {
      loading = Promise.resolve(cached);
      return loading;
    }
    loading = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var map = {};
        var count = 0;
        doc.querySelectorAll('.main-nav__child[id^="nav-dropdown-"]').forEach(function (el) {
          if (el.querySelector('[data-cc-nav-lite]')) return;
          map[el.id] = el.innerHTML;
          count += 1;
        });
        if (!count) return null;
        try { sessionStorage.setItem(storageKey, JSON.stringify({ t: Date.now(), m: map })); } catch (e) { /* quota */ }
        return map;
      })
      .catch(function () { return null; })
      .then(function (map) {
        if (!map) loading = null; // allow a retry later
        return map;
      });
    return loading;
  }

  function afterInject() {
    // Promos placed under the left column on desktop (same as cc-navigation-cards inline script).
    if (window.matchMedia('(min-width: 769px)').matches) {
      menu.querySelectorAll('.cc-card-menu').forEach(function (m) {
        var p = m.querySelector(':scope > .container > .child-promos');
        var sb = m.querySelector('.cc-cards-sidebar');
        if (p && sb) sb.appendChild(p);
      });
    }

    // "Sidebar" mega menus: hover listeners are bound by MainMenu at start-up only.
    var MainMenu = customElements.get('main-menu');
    var links = menu.querySelectorAll('.js-sidebar-hover');
    menu.sidebarLinks = links;
    if (MainMenu && window.theme && theme.mediaMatches && theme.mediaMatches.md && theme.device && theme.device.hasHover) {
      links.forEach(function (link) {
        if (link.dataset.ccBound) return;
        link.dataset.ccBound = '1';
        link.addEventListener('mouseenter', MainMenu.handleSidenavMenuToggle);
        link.addEventListener('focusin', MainMenu.handleSidenavFocusIn);
      });
      menu.mouseOverSidebarListening = true;
    }
  }

  function inject() {
    if (injected) return;
    load().then(function (map) {
      if (!map || injected) return;
      injected = true;
      Object.keys(map).forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.querySelector('[data-cc-nav-lite]')) el.innerHTML = map[id];
      });
      afterInject();
    });
  }

  // Insert on first intent to use the menu.
  ['touchstart', 'mouseover', 'focusin'].forEach(function (type) {
    menu.addEventListener(type, inject, { passive: true, once: true });
  });

  // Preload quietly once the page is displayed.
  function idlePreload() {
    if (readCache()) return;
    var run = function () { load(); };
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 4000 });
    else setTimeout(run, 1500);
  }
  if (document.readyState === 'complete') setTimeout(idlePreload, 1500);
  else window.addEventListener('load', function () { setTimeout(idlePreload, 1500); });
})();
